<template>
  <div class="opinionMain">
    <div class="title">舆情详情</div>
    <div class="content">
      <div class="item">
        <div class="name">舆情标题</div>
        <div class="text">{{opinionInfo.opinionTitle}}</div>
      </div>
      <div class="item">
        <div class="name">问题分类</div>
        <div class="text">{{opinionInfo.opinionType}}</div>
      </div>
      <div class="item">
        <div class="name">舆情级别</div>
        <div class="text">{{opinionInfo.opinionLevel}}</div>
      </div>
      <div class="item">
        <div class="name">网络走势</div>
        <div class="text">{{opinionInfo.netTend}}</div>
      </div>
      <div class="hide">
        <div class="item">
          <div class="name">信息来源</div>
          <div class="text">{{opinionInfo.infoSource}}</div>
        </div>
        <div class="item1">
          <div class="name">信息链接</div>
          <div class="link" @click="navTo(opinionInfo.infoUrl)">{{opinionInfo.infoUrl}}</div>
        </div>
        <div class="item">
          <div class="name2">是否涉及多个州市</div>
          <div class="text">{{opinionInfo.multiArea}}</div>
        </div>
        <div class="item">
          <div class="name2">州市扣分占比</div>
          <div class="text">{{opinionInfo.deducRate}}%</div>
        </div>
        <div class="item1">
          <div class="name">主要内容</div>
          <div class="text">
            {{opinionInfo.opinionDesc}}
          </div>
        </div>
      </div>
      <div class="btn" :class="isDescStatus?'':' on'" @click="showmoreDesc($event)">
        <span>{{!isDescStatus ? '收起' : '展开'}}</span>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'negativeDetail',
        data () {
            return {
                isDescStatus: true
            }
        },
        props: {
            opinionInfo: {
                type: Object
            }
        },
        methods: {
            navTo (url) {
                // window.location.href = url
                window.yyn.invokeJSB(
                    'openWindow', {
                        openUrl: url,
                        isFullScreen: 0,
                        setTitle: '',
                        needLoading: 1
                    },
                    cb => {
                        console.log(cb, 'callback');
                    }
                );
            },
            showmoreDesc (e) {
                let el = e.currentTarget;
                el.previousElementSibling.classList[!this.isDescStatus ? 'add' : 'remove']('hide');
                // el.classList[this.isDescStatus ? 'add' : 'remove']('more-collapse');
                // el.innerHTML = !this.isDescStatus ? '展开' : '收起';
                this.isDescStatus = !this.isDescStatus;
                this.isShowMore = true;
            }
        },
        mounted () {

        }
    }
</script>

<style lang="less" scoped>
  .opinionMain {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 24px;

    .title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }

    .content {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
      border-radius: 3px;
      margin-top: 12px;
      padding: 16px;

      .hide {
        display: none;
      }

      .item {
        display: flex;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        margin-bottom: 9px;
        line-height: 20px;

        .name {
          width: 72px;
          color: #999999;
        }

        .name2 {
          width: 124px;
          color: #999999;
        }

        .text {
          color: #333333;
          word-break: break-all;
          flex: 1;
        }

        .red {
          color: #FF4D4D;
        }
      }

      .item:last-child {
        margin-bottom: 0;
      }

      .item1 {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        margin-bottom: 9px;
        line-height: 20px;

        .name {
          min-width: 72px;
          color: #999999;
        }

        .link {
          color: rgba(54, 179, 116, 1);
          line-height: 22px;
          word-wrap: break-word;
        }

        .text {
          color: #333333;
          word-break: break-all;
          flex: 1;
        }
      }

      .btn {
        padding: 0 16px;
        text-align: center;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 14px;

        span {
          position: relative;
          padding-right: 11px;
        }

        span::after {
          content: '';
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 6px;
          height: 4px;
          background: url(../../../assets/image/jiantou.png) no-repeat;
          background-size: 6px 4px;
          background-position: right center;
        }
      }

      .btn.on {
        span::after {
          content: '';
          position: absolute;
          right: 0;
          top:50%;
          transform: translateY(-50%);
          width: 6px;
          height: 4px;
          background: url(../../../assets/image/jiantou-d.png) no-repeat;
          background-size: 6px 4px;
          background-position: right center;
        }
      }
    }

  }
</style>
